import React, { useEffect, useState, useRef } from "react";
import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import "../Messages.css";

export default function Phonelessstudents({ activename, updatesent, setSelectedpass, currentstudentid, arrayofstudentpasses, idselected, setArrayofstudentpassees, studentname, multipleofdays, numberofdaysago, lastupdate, filteredstates, setFilteredstates }) {

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();


  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [visibleActivePasses, setVisibleActivePasses] = useState([]);
  const [visibleFilteredPasses, setVisibleFilteredPasses] = useState([]);
  const [visibleAllPasses, setVisibleAllPasses] = useState([]);
  const [visibleDatePasses, setVisibleDatePasses] = useState([]);

  // Add firebase reference if not already imported at the top level
  useEffect(() => {

    console.log("Active passes changed:", activpasses?.length);
    console.log("Visible passes:", visibleActivePasses);

    if (Array.isArray(activpasses) && activpasses.length > 0) {

      const missingIds = activpasses.filter(p => !p.id).map((p, i) => ({ index: i, pass: p }));
      if (missingIds.length > 0) {
        console.warn("Passes missing IDs:", missingIds);
      }
      // Reset visible passes when the component mounts or passes change
      setVisibleActivePasses([]);

      // Staggered animation to reveal passes one by one
      activpasses.forEach((pass, index) => {
        setTimeout(() => {
          setVisibleActivePasses(prev => [...prev, pass.id || index]);
        }, 100 * index); // 100ms delay between each pass
      });
    }
  }, [activpasses]);

  // Functions to handle pass action
  const returnpasstoclass = async (value) => {
    if (value && value.returned !== 1) {
      try {
        console.log("Switching pass direction for return to class:", value.id);

        const nowTime = Date.now();

        // Set new time allowed to 6 minutes for return journey
        const newTimeallowedonpass = 6;
        const newExpectedReturn = nowTime + (newTimeallowedonpass * 60000);

        // Format current time for display
        const currentDate = new Date();
        const formattedTime = currentDate.toLocaleTimeString([], {
          hour12: true,
          timeStyle: "short",
        });

        // Format expected return time
        const expectedReturnDate = new Date(newExpectedReturn);
        const formattedExpectedReturn = expectedReturnDate.toLocaleTimeString([], {
          hour12: true,
          timeStyle: "short",
        });

        // Set new destination based on comingfrom or fallback to "Back to class"
        const newDestination = value.comingfrom ? value.comingfrom.trim() : "";
        const finalDestination = newDestination === "" ? "Back to class" : newDestination;

        // Prepare updated pass data - swap destination and coming from
        const updatedPassData = {
          // Time fields - reset to now as starting point
          leftclass: nowTime,
          timeleftclass: formattedTime,
          timepassinitiated: nowTime,
          timeallowedonpass: newTimeallowedonpass,
          whenlimitwillbereached: newExpectedReturn,
          expectedtimeofarrival: formattedExpectedReturn,

          // Direction fields - use finalDestination for destination
          destination: finalDestination,
          comingfrom: value.destination || "Office",

          // Reset return fields
          returned: 0,
          timereturned: null,
          returnedbeforetimelimit: null,
          differenceoverorunderinminutes: null
        };

        // Update the pass in Firebase
        await updateDoc(doc(firebase, "passes", value.id), updatedPassData);


  if (value.teacherid) {
        await updateDoc(doc(firebase, "users", value.teacherid), {
          addingnumber: Date.now(),
          idofstudent: value.studentid,
          passnumber: value.id
        });
      }


        // Create the fully updated pass object by merging the original with updates
        const updatedPass = { ...value, ...updatedPassData };

        // Update local storage - all passes
        let allPasses = JSON.parse(localStorage.getItem("allpasses")) || [];
        let updatedPasses = allPasses.map(p => {
          if (p.id === value.id) {
            return updatedPass;
          }
          return p;
        });
        localStorage.setItem("allpasses", JSON.stringify(updatedPasses));
        setlasttwomonths(updatedPasses);

        // Update active passes
        let activePasses = JSON.parse(localStorage.getItem("onpass")) || [];

        // First check if the pass is already in active passes
        const passExists = activePasses.some(p => p.id === value.id);

        if (passExists) {
          // Update existing active pass
          activePasses = activePasses.map(p => {
            if (p.id === value.id) {
              return updatedPass;
            }
            return p;
          });
        } else {
          // Add to active passes if not present
          activePasses.push(updatedPass);
        }

        localStorage.setItem("onpass", JSON.stringify(activePasses));
        setActivpasses(activePasses);

        // CRITICAL: Update the selected pass in the parent component to show changes immediately
        setSelectedpass(updatedPass);

    setTimeout(() => {
  // First clear the selected pass
  setSelectedpass("");

  // Always update activpasses
  setActivpasses(prevActivPasses => {
    // This creates a new array reference which will trigger the useEffect
    return [...prevActivPasses];
  });
  
  // Additionally update filteredstates and lasttwomonths if we're in Search By Name view
  if (activename === "Search By Name") {
    // Get the latest allpasses from localStorage to ensure everything is in sync
    let latestAllPasses = JSON.parse(localStorage.getItem("allpasses")) || [];
    
    // Update lasttwomonths to ensure it has latest data
    setlasttwomonths(latestAllPasses);
    
    // Update filteredstates based on the latest data
    // This will re-filter based on the search term
    let updatedFilteredStates = latestAllPasses.filter(pass => {
      // Match any field that contains the search term (case insensitive)
      for (let prop in pass) {
        let lower = JSON.stringify(pass[prop]).toLowerCase();
        if (lower.includes(studentname.toString().toLowerCase(), 1)) {
          return true;
        }
      }
      return false;
    });
    
    setFilteredstates(updatedFilteredStates);
  }
}, 1000);

        console.log(`Pass for ${value.firstname} ${value.lastname} updated for return journey to ${updatedPassData.destination}`);
      } catch (error) {
        console.error("Error updating pass for return journey:", error);
        alert("There was a problem updating the pass: " + error.message);
      }
    } else if (value) {
      alert("This pass has already been completed and cannot be modified.");
    }
  };
  // ...existing code...

  useEffect(() => {

    if (typeof numberofdaysago != "undefined") {
      setChangehasbeenmade(true);
      let now = Date.now();
      if (numberofdaysago == 0) {
        setEndtime(now);
        setBegintime(now - (1000 * 60 * 60 * 12))
      } else {
        setEndtime(now - ((numberofdaysago * (1000 * 60 * 60 * 24)) - (1000 * 60 * 60 * 12)));
        setBegintime(now - ((numberofdaysago * (1000 * 60 * 60 * 24)) + (1000 * 60 * 60 * 12)));
      }
    }
  }, [numberofdaysago, activename]);


  useEffect(() => {

    if (typeof numberofdaysago != "undefined") {
      setChangehasbeenmade(true);
      let now = Date.now();
      if (numberofdaysago == 0) {
        setEndtime(now);
        setBegintime(now - (1000 * 60 * 60 * 12))
      } else {
        setEndtime(now - ((numberofdaysago * (1000 * 60 * 60 * 24)) - (1000 * 60 * 60 * 12)));
        setBegintime(now - ((numberofdaysago * (1000 * 60 * 60 * 24)) + (1000 * 60 * 60 * 12)));
      }
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      let now = Date.now();
      setUpdate(now);
    }, 10000);

    return () => clearInterval(timer); // Clean up on unmount
  }, []);

  const selectHandler = (value) => {
    // Log the exact value for debugging
    console.log("selectHandler received:", value);

    // If clicking on a valid pass (has an id)
    if (value && typeof value === 'object' && value.id) {
      // If this pass is already selected, deselect it
      if (String(value.id) === String(idselected)) {
        setSelectedpass("");
        console.log("Deselected:", value.id);
      }
      // Otherwise select it
      else {
        setSelectedpass(value);
        console.log("Selected:", value.id, "Type:", typeof value.id);
      }
    } else {
      // Handle empty selection with more detailed error info
      setSelectedpass("");
      console.log("Selection cleared. Value type:", typeof value,
        "Has ID:", value && 'id' in value);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      let classids = JSON.parse(localStorage.getItem("allpasses")) || [];
      setlasttwomonths(classids);

      let activep = JSON.parse(localStorage.getItem("onpass")) || [];

      if (Array.isArray(activep)) {
        activep.forEach((pass, index) => {
          if (!pass.id) {
            console.warn(`Pass at index ${index} is missing an ID:`, pass);
          }
        });
      }
      setActivpasses(activep);
    }, 1000);
  }, []);


  useEffect(() => {
    setTimeout(() => {
      let classids = JSON.parse(localStorage.getItem("allpasses")) || [];
      setlasttwomonths(classids);

      let activep = JSON.parse(localStorage.getItem("onpass")) || [];
      setActivpasses(activep);
    }, 1000);
  }, [updatesent, lastupdate]);

  useEffect(() => {
    console.log(activename, "hellooooo");

  }, [activename]);

  useEffect(() => {
    console.log(numberofdaysago, "number of days ago update");

  }, [numberofdaysago]);


  useEffect(() => {
    const allofthisstudents = lasttwomonths.filter((person) => {
      return person.studentid == currentstudentid;
    });
    setArrayofstudentpassees(allofthisstudents);
  }, [currentstudentid]);



const textsearchedstates = () => {
  setSearchingstate(true);
  
  if (!studentname || studentname.trim() === "") {
    setFilteredstates([]);
    setSearchingstate(false);
    return;
  }
  
  const searchTerm = studentname.toString().toLowerCase().trim();
  
  // Only search in relevant fields rather than ALL properties
  const relevantFields = ['firstname', 'lastname', 'studentid', 'destination', 'comingfrom'];
  
  const results = lasttwomonths.filter(pass => {
    // Check only relevant fields
    return relevantFields.some(field => {
      if (!pass[field]) return false;
      return String(pass[field]).toLowerCase().includes(searchTerm);
    });
  });
  
  console.log(`Found ${results.length} passes matching "${searchTerm}"`);
  setFilteredstates(results);
  setSearchingstate(false);
}


  useEffect(() => {
    if (studentname) {
      textsearchedstates(studentname)
      console.log("this stae has been input", studentname)
    }
  }, [studentname])


  useEffect(() => {
    if (typeof begintime != "undefined" && typeof endtime != "undefined") {

      console.log("begin time and end time was run");

      const betweendays = lasttwomonths.filter((person) => {
        return person.timepassinitiated > begintime && person.timepassinitiated < endtime;
      });
      setPassesbetween(betweendays);
    }
  }, [begintime, endtime])

  useEffect(() => {
    if (Array.isArray(filteredstates) && filteredstates.length > 0) {
      setVisibleFilteredPasses([]);

      filteredstates.forEach((pass, index) => {
        setTimeout(() => {
          setVisibleFilteredPasses(prev => [...prev, pass.id || index]);
        }, 100 * index);
      });
    }
  }, [filteredstates]);

  // Add animation effects for all passes (when viewing all passes)
  useEffect(() => {
    if (Array.isArray(lasttwomonths) && lasttwomonths.length > 0) {
      setVisibleAllPasses([]);

      lasttwomonths.forEach((pass, index) => {
        setTimeout(() => {
          setVisibleAllPasses(prev => [...prev, pass.id || index]);
        }, 100 * index);
      });
    }
  }, [lasttwomonths]);

  // Add animation effects for passes between dates
  useEffect(() => {
    if (Array.isArray(passesbetween) && passesbetween.length > 0) {
      setVisibleDatePasses([]);

      passesbetween.forEach((pass, index) => {
        setTimeout(() => {
          setVisibleDatePasses(prev => [...prev, pass.id || index]);
        }, 100 * index);
      });
    }
  }, [passesbetween]);

  return (
    <div className="inner123">
      {activename == "Active Passes" && typeof idselected != "undefined" ?
        <>
          {typeof activpasses != "undefined" &&
            activpasses != null &&
            // Only show passes where the ID matches idselected
            activpasses.filter(item => item.id == idselected).map((item, index) => (

              <div key={item.id} className={visibleActivePasses.includes(item.id || index) ? "student-visible" : "student-hidden"}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {/* Student Photo or Placeholder */}
                 

                  {/* Pass Information */}
                  <div className={update > item.whenlimitwillbereached ? "passend" : update > (item.leftclass + (.8 * item.timeallowedonpass * 60000)) ? "passmiddle" : "passstart"}
                    onClick={() => {
                      if (item && item.id) {
                        selectHandler(item);
                      } else {
                        console.warn("Attempted to select invalid pass:", item);
                      }
                    }}
                    style={{ flex: 1, display: "flex", alignItems: "center", gap: "12px" }}>
                    
                 <div style={{
                      width: "80px",
                      height: "80px",
                      minWidth: "80px",
                      minHeight: "80px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#013469",
                       color: "#013469"
                    }}>
                      {item.studentPhotoUrl ? (
                        <img
                          src={item.studentPhotoUrl}
                          alt={`${item.firstname} ${item.lastname}`}
                          style={{
                            width: "200%",
                            height: "200%",
                            objectFit: "cover"
                          }}
                        />
                      ) : (
                        <svg
                          viewBox="0 0 24 24"
                          style={{
                            width: "100%",
                            height: "100%",
                            padding: "4px"
                          }}
                        >
                        <circle cx="12" cy="8" r="4" fill="#999" />
                          <path d="M 12 14 C 8 14 4 16 4 20 L 20 20 C 20 16 16 14 12 14 Z" fill="#999" />
                        </svg>
                      )}
                    </div> 

                    {/* Text Content */}
                    <div style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center"
                    }}>
                      {item.firstname} {item.lastname}
                      <br></br>
                         {item.studentemail}
                          <br></br>
                      {new Date(item.leftclass).toString().substr(4, 11)} @{" "}
                      {item.timeleftclass}
                      <br></br>
                      {item.comingfrom} to {item.destination} - {item.timeallowedonpass}{" "}
                      min.
                    </div>
                  </div>
                </div>

                <div></div>


                {item.returned === 0 ?
                  <div className="passstart" onClick={() => returnpasstoclass(item)} style={{ width: "100%" }}>
                    <div className="innertext">Send {item.firstname} Back To Class</div>
                  </div>
                  : null}
              </div>

            ))
          }



          <br></br>
          <br></br>
          <br></br>
          <br></br>
        </>
        : activename == "Active Passes" && typeof idselected == "undefined" && activpasses.length == 0 ?
          <>
            <div className="Emoji">🤓</div>
            <div className="passsnotice"> They love being in class.
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </>
          : activename == "Active Passes" && typeof idselected == "undefined" && (activpasses || []).length != 0 ?
            <>
              {typeof activpasses != "undefined" &&
                activpasses != null &&
                activpasses.map((item, index) => (
                  <div key={item.id} className={visibleActivePasses.includes(item.id || index) ? "student-visible" : "student-hidden"}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      {/* Student Photo or Placeholder */}
                     

                      {/* Pass Information */}
                      <div className={update > item.whenlimitwillbereached ? "passend" : update > (item.leftclass + (.8 * item.timeallowedonpass * 60000)) ? "passmiddle" : "passstart"}
                        onClick={() => {
                          if (item && item.id) {
                            selectHandler(item);
                          } else {
                            console.warn("Attempted to select invalid pass:", item);
                          }
                        }}
                        style={{ flex: 1, display: "flex", alignItems: "center", gap: "12px" }}>
                        
                        {/* Photo */}
                       <div style={{
                          width: "80px",
                          height: "80px",
                          minWidth: "80px",
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "8px",
                          overflow: "hidden",
                          backgroundColor: "#013469",
                          color: "#013469"
                        }}>
                          {item.studentPhotoUrl ? (
                            <img
                              src={item.studentPhotoUrl}
                              alt={`${item.firstname}`}
                           
                              style={{
                                width: "200%",
                                height: "200%",
                                objectFit: "cover"
                              }}
                            />
                          ) : (
                            <svg
                              viewBox="0 0 24 24"
                              style={{
                                width: "100%",
                                height: "100%",
                                padding: "4px"
                              }}
                            >
                         
                              <circle cx="12" cy="8" r="4" fill="#999" />
                              <path d="M 12 14 C 8 14 4 16 4 20 L 20 20 C 20 16 16 14 12 14 Z" fill="#999" />
                            </svg>
                          )}
                        </div>

                        {/* Text Content */}
                        <div style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center"
                        }}>
                          {item.firstname} {item.lastname}
                          <br></br>
                           {item.studentemail}
                          <br></br>
                          {new Date(item.leftclass).toString().substr(4, 11)} @{" "}
                          {item.timeleftclass}
                          <br></br>
                          {item.comingfrom} to {item.destination} - {item.timeallowedonpass}{" "}
                          min.
                        </div>
                      </div>
                    </div>

                  </div>
                ))}

              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </>
            // ...existing code for other cases...
            : activename == "Search By Name" && studentname != "" && typeof idselected != "undefined" ? <>
              {typeof filteredstates != "undefined" &&
                filteredstates != null &&
                filteredstates.filter(item => item.id == idselected).map((item, index) => (

                  <div key={item.id} className={visibleActivePasses.includes(item.id || index) ? "student-visible" : "student-hidden"} style={{ marginLeft: "auto", marginRight: "auto" }} >
                    <div className={update > item.whenlimitwillbereached ? "passend" : update > (item.leftclass + (.8 * item.timeallowedonpass * 60000)) ? "passmiddle" : "passstart"}
                      onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                      {item.firstname} {item.lastname}
                      <br></br>
                         {item.studentemail}
                          <br></br>
                      {new Date(item.leftclass).toString().substr(4, 11)} @{" "}
                      {item.timeleftclass}
                      <br></br>
                      {item.comingfrom} to {item.destination} - {item.timeallowedonpass}{" "}
                      min.
                    </div>

                    <div></div>


                    {item.returned === 0 ?
                      <div className="passstart" onClick={() => returnpasstoclass(item)} style={{ width: "100%" }}>
                        <div className="innertext">Send {item.firstname} Back To Class</div>
                      </div>
                      : null}
                  </div>

                ))}
            </> : activename == "Search By Name" && studentname != "" ? <>
              {typeof filteredstates != "undefined" &&
                filteredstates != null &&
                filteredstates.map((item, index) => (
                  <div key={item.id} className={visibleFilteredPasses.includes(item.id || index) ? "student-visible" : "student-hidden"} style={{ marginLeft: "auto", marginRight: "auto" }}>
                    {item.timereturned ?
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>Time Returned: {item.timereturned}<br></br>Time Out Of Class: {(Math.round((item.timeallowedonpass - item.differenceoverorunderinminutes) * 10)) / 10} min.
                      </div>
                      :
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>This Pass Is Still Active.
                      </div>
                    }

                  </div>
                ))}
            </> : activename == "Search By Name" && studentname == "" ? <>
              {typeof lasttwomonths != "undefined" &&
                lasttwomonths != null &&
                lasttwomonths.map((item, index) => (
                  <div key={item.id} className={visibleAllPasses.includes(item.id || index) ? "student-visible" : "student-hidden"} style={{ marginLeft: "auto", marginRight: "auto" }}>
                    {item.timereturned ?
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>Time Returned: {item.timereturned}<br></br>Time Out Of Class: {(Math.round((item.timeallowedonpass - item.differenceoverorunderinminutes) * 10)) / 10} min.
                      </div>
                      :
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>This Pass Is Still Active.
                      </div>
                    }

                  </div>
                ))}
            </> : activename == "Search By Date" ? <>
              {typeof passesbetween != "undefined" &&
                passesbetween != null &&
                passesbetween.map((item, index) => (
                  <div key={item.id} className={visibleDatePasses.includes(item.id || index) ? "student-visible" : "student-hidden"} style={{ marginLeft: "auto", marginRight: "auto" }}>
                    {item.timereturned ?
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>Time Returned: {item.timereturned}<br></br>Time Out Of Class: {(Math.round((item.timeallowedonpass - item.differenceoverorunderinminutes) * 10)) / 10} min.
                      </div>
                      :
                      <div className={item.differenceoverorunderinminutes > 0 ? "passstart" : "passend"} onClick={() => {
                        if (item && item.id) {
                          selectHandler(item);
                        } else {
                          console.warn("Attempted to select invalid pass:", item);
                        }
                      }}>
                        {item.firstname} {item.lastname}<br></br>{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}<br></br>{item.comingfrom} to {item.destination} - {item.timeallowedonpass} min.<br></br>This Pass Is Still Active.
                      </div>
                    }

                  </div>
                ))}
            </> : null}
    </div>
  );
}

{
  /* <View>
<Pressable
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onPress={() => selectHandler(item)}>
  <Text style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</Text>
</Pressable>


</View> */
}